import React from 'react';

export const ReviewCountField = ({ state, disabled }) => (
  <div className="max-w-full text-xs" data-testid="email-review-count-control">
    <div className="flex flex-wrap items-center gap-2">
      <label htmlFor="email-review-count" className="text-gray-600">Google review count</label>
      <input id="email-review-count" data-testid="email-review-count-input" type="number" inputMode="numeric"
        min="0" max="9999999" step="1" value={state.draft} onChange={event => state.change(event.target.value)}
        onKeyDown={event => { if (event.key === 'Enter') { event.preventDefault(); state.retry(); } }}
        disabled={disabled || !state.ready} aria-invalid={!!state.error}
        aria-describedby={state.error ? 'email-review-count-error' : undefined}
        className="min-h-[36px] w-24 min-w-0 rounded border border-gray-300 px-2 py-1.5 text-sm outline-none transition-colors focus:border-green-600 focus:ring-2 focus:ring-green-100 disabled:bg-gray-100" />
      <span role="status" data-testid="email-review-count-save-status" className="text-gray-500">{state.busy ? 'Saving…' : state.didSave ? 'Saved' : ''}</span>
    </div>
    {state.error && <div id="email-review-count-error" role="alert" data-testid="email-review-count-error" className="mt-1 max-w-sm break-words text-red-700">
      {state.error}
      {state.canRetry && !state.saving && <button type="button" onClick={state.retry} disabled={disabled} title="Retry saving review count" aria-label="Retry saving review count"
        data-testid="email-review-count-retry" className="ml-2 inline-flex min-h-[32px] min-w-[32px] items-center justify-center rounded text-lg transition-colors hover:bg-red-50">↻</button>}
    </div>}
  </div>
);